// 1.without button code 

// import { Box, Card, CardActions, CircularProgress, Container, CssBaseline, Paper, Stack, Typography, useTheme } from '@mui/material'
// import React, { useContext, useRef, useState } from 'react'
// import FilterStrip from '../../../../../../components/FilterStrip'
// import SingleLineChart from '../../../../../../components/charts/SingleLineChart'
// import EnergyReportingChart from '../../../../../../components/charts/energy_reporting/EnergyReportingChart'

// import { InverterContext } from '../../../../../../context/InverterContext'

// import LineChart from '../../../../../../components/charts/LineChart'
// import { getDateTimeForDashboardTab1 } from '../../../../../../utils'
// import AppModal from '../../../../../../components/AppModal'

// function DailyEnergyCurve() {
//     const chartRef = useRef();
//     const { palette, breakpoints, spacing } = useTheme()
//     const { getGridLoadData, InverterChartData, InvChartLoading, getInverterChartData } = useContext(InverterContext)
//     let ChartLabel = []
//     let datasetArr = []
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
//     const LCODE = localStorage.getItem('LCODE')

//     const [open, setOpen] = React.useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     function onRefreshData() {
//         if (StartDate.length !== 0 && EndDate.length !== 0) {
//             getInverterChartData(LCODE, StartDate, EndDate)
//         } else {
//             alert('please provide any date')
//         }

//     }

//     function getRandomColor() {
//         var letters = '0123456789ABCDEF';
//         var color = '#';
//         for (var i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     }
//     let ChartData = new Object();
//     if (InverterChartData) {
//         InverterChartData.forEach((singleData, index) => {
//             let ChartKey = Object.keys(InverterChartData[0])
//             ChartKey = ChartKey.filter(value => value.includes(' Day Total[KWH]'))
//             ChartLabel.push(singleData.Date)
//             for (let i = 0; i < ChartKey.length; i++)
//                 if (index == 0)
//                     ChartData[ChartKey[i]] = [singleData[ChartKey[i]]]
//                 else
//                     ChartData[ChartKey[i]].push(singleData[ChartKey[i]])
//         });
//         // preparing data

//         for (let prop in ChartData) {
//             datasetArr.push({
//                 label: prop.replace(" Day Total[KWH]", ""),
//                 data: ChartData[prop],
//                 borderColor: getRandomColor(),
//                 backgroundColor: getRandomColor(),
//                 tension: 0.3,
//                 borderWidth: 0.9,
//                 pointRadius: 1,
//                 pointHoverRadius: 1,
//             })
//         }
//         // console.log('datasetArr', datasetArr)
//         // setDatasetArray([...datasetArr])
//     } else {
//         // console.log('data not set')

//     }


//     return (
//         <>
//             <CssBaseline />
//             <Box component={Stack} sx={{ bgcolor: 'background.default', rowGap: spacing(1), py: spacing(1) }}>
//                 <FilterStrip
//                     title={'Daily Energy Curve'}
//                     ValueOf1={StartDate}
//                     ValueOf2={EndDate}
//                     onChangeValueOf1={(val) => setStartDate(val.target.value)}
//                     onChangeValueOf2={(val) => setEndDate(val.target.value)}
//                     onFullScreen={handleOpen}
//                     onRefreshData={onRefreshData}
//                     chartRef={chartRef}
//                 />
//                 {
//                     InvChartLoading ? <Typography variant='body2' textAlign={'center'} color={'primary.main'}>Data Loading.........</Typography> :
//                         datasetArr?.length == 0 ?
//                             <Typography variant='body2' color={'error.main'} textAlign={"center"}>Data not found</Typography>
//                             :
//                             <>
//                                 <Card ref={chartRef}>
//                                     <CardActions>
//                                         <Container maxWidth={false}>
//                                             <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
//                                         </Container>
//                                     </CardActions>
//                                 </Card>
//                                 <AppModal
//                                     open={open}
//                                     handleClose={handleClose}
//                                 >
//                                     <Box>
//                                         <Typography variant='h5' textAlign={'center'}>Daily Energy Curve</Typography>
//                                         <Container maxWidth={false}>
//                                             <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
//                                         </Container>
//                                     </Box>
//                                 </AppModal>
//                             </>
//                 }

//             </Box>
//         </>
//     )
// }

// export default DailyEnergyCurve


import React, { useRef, useState, useContext } from "react";
import { Box, Card, CardActions, Container, CssBaseline, Stack, Typography, ButtonGroup, Button } from "@mui/material";
import FilterStrip from "../../../../../../components/FilterStrip";
import AppModal from "../../../../../../components/AppModal";

import { InverterContext } from "../../../../../../context/InverterContext";

import EnergyReportingChart from "../../../../../../components/charts/energy_reporting/EnergyReportingChart"; // Line Chart Component
import EnergyReportingBarChart from "../../../../../../components/charts/energy_reporting/EnergyReportingBarChart"; // Bar Chart Component
import { getDateTimeForDashboardTab1 } from "../../../../../../utils";
import { useTheme } from "@emotion/react";

function DailyEnergyCurve() {
    const { palette, spacing } = useTheme()
    const chartRef = useRef();
    const { InverterChartData, InvChartLoading, getInverterChartData } = useContext(InverterContext);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
    const LCODE = localStorage.getItem("LCODE");

    const [selectedChart, setSelectedChart] = useState("line"); // "line" or "bar"
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            getInverterChartData(LCODE, StartDate, EndDate);
        } else {
            alert("please provide any date");
        }
    }

    function getRandomColor() {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    let ChartLabel = [];
    let datasetArr = [];

    if (InverterChartData) {
        InverterChartData.forEach((singleData, index) => {
            let ChartKey = Object.keys(InverterChartData[0]).filter(value => value.includes(" Day Total[KWH]"));
            ChartLabel.push(singleData.Date);
            ChartKey.forEach((key) => {
                if (index === 0) {
                    if (!datasetArr.find(ds => ds.label === key.replace(" Day Total[KWH]", ""))) {
                        datasetArr.push({
                            label: key.replace(" Day Total[KWH]", ""),
                            data: [singleData[key]],
                            borderColor: getRandomColor(),
                            backgroundColor: getRandomColor(),
                            tension: 0.3,
                            borderWidth: 0.9,
                            pointRadius: 1,
                            pointHoverRadius: 1,
                        });
                    }
                } else {
                    let ds = datasetArr.find(ds => ds.label === key.replace(" Day Total[KWH]", ""));
                    if (ds) {
                        ds.data.push(singleData[key]);
                    }
                }
            });
        });
    }

    return (
        <>
            <CssBaseline />
            <Box component={Stack} sx={{ bgcolor: "background.default", rowGap: 1, py: 1 }}>
                <FilterStrip
                    title={"Daily Energy Curve"}
                    ValueOf1={StartDate}
                    ValueOf2={EndDate}
                    onChangeValueOf1={(val) => setStartDate(val.target.value)}
                    onChangeValueOf2={(val) => setEndDate(val.target.value)}
                    onFullScreen={handleOpen}
                    onRefreshData={onRefreshData}
                    chartRef={chartRef}
                />

                {/* Chart Type Selector */}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        mb: 2,
                    }}
                >
                    <ButtonGroup
                        variant="outlined"
                        aria-label="chart type selector"
                        sx={{
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        }}
                    >
                        <Button
                            size="small"
                            sx={{
                                fontSize: "12px",
                                fontWeight: "600",
                                textTransform: "none",
                                px: 2,
                                py: 0.8,
                                borderColor: selectedChart === "line" ? palette.primary.main : "#ccc",
                                backgroundColor: selectedChart === "line" ? palette.primary.main : "white",
                                color: selectedChart === "line" ? "white" : "#333",
                                "&:hover": {
                                    backgroundColor: selectedChart === "line" ? palette.primary.main : "#f1f1f1",
                                    borderColor: palette.primary.main,
                                },
                            }}
                            onClick={() => setSelectedChart("line")}
                        >
                            📈 Line
                        </Button>

                        <Button
                            size="small"
                            sx={{
                                fontSize: "12px",
                                fontWeight: "600",
                                textTransform: "none",
                                px: 2,
                                py: 0.8,
                                borderColor: selectedChart === "bar" ? "#1976d2" : "#ccc",
                                backgroundColor: selectedChart === "bar" ? "#1976d2" : "white",
                                color: selectedChart === "bar" ? "white" : "#333",
                                "&:hover": {
                                    backgroundColor: selectedChart === "bar" ? "#1565c0" : "#f1f1f1",
                                    borderColor: "#1976d2",
                                },
                            }}
                            onClick={() => setSelectedChart("bar")}
                        >
                            📊 Bar
                        </Button>
                    </ButtonGroup>
                </Box>



                {
                    InvChartLoading ? (
                        <Typography variant="body2" textAlign={"center"} color={"primary.main"}>
                            Data Loading.........
                        </Typography>
                    ) : datasetArr.length === 0 ? (
                        <Typography variant="body2" color={"error.main"} textAlign={"center"}>
                            Data not found
                        </Typography>
                    ) : (
                        <>
                            <Card ref={chartRef}>
                                <CardActions>
                                    <Container maxWidth={false}>
                                        {selectedChart === "line" ? (
                                            <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
                                        ) : (
                                            <EnergyReportingBarChart data={datasetArr} labels={ChartLabel} />
                                        )}
                                    </Container>
                                </CardActions>
                            </Card>

                            <AppModal open={open} handleClose={handleClose}>
                                <Box>
                                    <Typography variant="h5" textAlign={"center"}>
                                        Daily Energy Curve
                                    </Typography>
                                    <Container maxWidth={false}>
                                        {selectedChart === "line" ? (
                                            <EnergyReportingChart data={datasetArr} labels={ChartLabel} />
                                        ) : (
                                            <EnergyReportingBarChart data={datasetArr} labels={ChartLabel} />
                                        )}
                                    </Container>
                                </Box>
                            </AppModal>
                        </>
                    )
                }
            </Box>
        </>
    );
}

export default DailyEnergyCurve;
